import {observer} from 'mobx-react';
import {QuickTip} from 'shared/components';
import {calendarDate} from 'shared/tools';
import {FormattedMessage} from 'react-intl';
import _ from 'lodash';

const WARNING_EXPLANATIONS = {
  retroactive_pay_rates: 'nmbr.updates.directory.RETROACTIVE_CHANGES_WARNING',
  retroactive_synced_hours: 'nmbr.updates.directory.CHANGES_NOT_SYNCED_WARNING'
};

const RetroactiveChangesWarning = observer(({nmbrUpdate}) => {
  if (_.isEmpty(nmbrUpdate.retroactiveFieldUpdates)) return null;

  return (
    <div className='mb2 space-y'>
      {nmbrUpdate.retroactiveFieldUpdates.map(fieldUpdate => (
        <QuickTip
          key={fieldUpdate.index}
          trait='caution'
          header={<FormattedMessage id='nmbr.updates.directory.Manual Intervention Required'/>}
        >
          <FormattedMessage
            id={WARNING_EXPLANATIONS[fieldUpdate.updateType]}
            values={{
              effectiveDate: calendarDate(fieldUpdate.effectiveDate),
              cutoffDate: calendarDate(fieldUpdate.cutoffDate)
            }}
          />
        </QuickTip>
      ))}
    </div>
  );
});

export default RetroactiveChangesWarning;
